import React from 'react';
import TextField from '@mui/material/TextField';
import { FormGroup, FormLabel } from '@mui/material';

const EmailInput = ({ name, label, value, placeholder, onChange, disabled = false }) => {
    return (
        <FormGroup>
            <FormLabel>{label}</FormLabel>
            <TextField
                type="email"
                value={value}
                onChange={onChange}
                disabled={disabled}
                placeholder={placeholder}
                variant="outlined"
                name={name}
                fullWidth
                className="email-input"
                sx={{
                    marginBottom: '10px',
                    borderRadius: '8px',
                    background: '#242629',
                }}
            />
        </FormGroup>
    );
};

export default EmailInput;
